module.exports = __webpack_public_path__ + "img/feather_icon.023ba082.svg";